import {apiSlice} from './apiSlice';

/**
 * Dashboard thống kê admin (mục V) — features/Member/AdminStats. Chỉ đọc, tổng hợp.
 * Không gắn tag (không có mutation ghi vào stats); refetch khi vào trang.
 */
export const adminStatsApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getAdminStats: builder.query({
			query: () => ({url: 'admin/stats', method: 'get'}),
			transformResponse: (body) => body?.data || null,
		}),
	}),
});

export const {useGetAdminStatsQuery} = adminStatsApiSlice;
